import AgentsTable from "./agents-table";

export default AgentsTable;
